var render = function render(){var _vm=this,_c=_vm._self._c;return _c('detail-form',{ref:"dForm",attrs:{"by-assets":true,"assets-list":_vm.assetsList,"typeList":_vm.typeList,"budget-detail-list":_vm.budgetDetailList,"orgList":_vm.orgList,"data":_vm.chooseData},on:{"dataUpdate":_vm.dataUpdate}})
}
var staticRenderFns = []

export { render, staticRenderFns }